export default "/images/framework/Key.d984f09c.svg?d984f09c";